import { render, staticRenderFns } from "./ShipToAddressSelector.vue?vue&type=template&id=55f24d23"
import script from "./ShipToAddressSelector.vue?vue&type=script&lang=js"
export * from "./ShipToAddressSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports